export default {
  dateSelection(state) {
    return state.dateSelection;
  },
  empresa(state) {
    return state.empresa;
  },
  centroCusto(state) {
    return state.centroCusto;
  },
  produto(state) {
    return state.produto;
  },
  projeto(state) {
    return state.projeto;
  },
  responsavel(state) {
    return state.responsavel;
  },
  filterBySaving(state) {
    return state.filterBySaving;
  },
  grupo(state) {
    return state.grupo;
  },
  fornecedor(state) {
    return state.fornecedor;
  },
  solicitante(state) {
    return state.solicitante;
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.responsavel && state.responsavel.length,
      state.produto && state.produto.length,
      state.centroCusto && state.centroCusto.length,
      state.projeto && state.projeto.length,
      state.grupo && state.grupo.length,
      state.fornecedor && state.fornecedor.length,
      state.solicitante && state.solicitante.length,
      state.filterBySaving,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = [];

    if (state.empresa && state.empresa.id) {
      filters.push(`(comprador.id = ${state.empresa.id})`);
    }
    if (state.responsavel && state.responsavel.length) {
      const responsaveisFilter = state.responsavel.map(responsavel => `(responsavel.id = ${responsavel.id})`);
      filters.push(`(${responsaveisFilter.join(' or ')})`);
    }
    if (state.centroCusto && state.centroCusto.length) {
      const centroCustosFilter = state.centroCusto.map(centroCusto => `(centroCusto.id = ${centroCusto.id} or produto.centroCusto.id = ${centroCusto.id})`);
      filters.push(`(${centroCustosFilter.join(' or ')})`);
    }
    if (state.produto && state.produto.length) {
      const produtosFilter = state.produto.map(produto => `(produto.id = ${produto.id})`);
      filters.push(`(${produtosFilter.join(' or ')})`);
    }
    if (state.projeto && state.projeto.length) {
      const projetoFilter = state.projeto.map(projeto => `(projeto.id = ${projeto.id} or produto.projeto.id = ${projeto.id})`);
      filters.push(`(${projetoFilter.join(' or ')})`);
    }
    if (state.dateSelection) {
      filters.push(`(dataRegistro >= ${state.dateSelection.initialDate} and dataRegistro <= ${state.dateSelection.finalDate})`);
    }
    if (state.filterBySaving) {
      filters.push('(saving > 0)');
    }
    if (state.grupo && state.grupo.length) {
      const grupoFilter = state.grupo.map(categoria => `(produto.categoria.id = ${categoria.id})`);
      filters.push(`(${grupoFilter.join(' or ')})`);
    }
    if (state.fornecedor && state.fornecedor.length) {
      const fornecedorFilter = state.fornecedor.map(fornecedor => `(fornecedor.id = ${fornecedor.id})`);
      filters.push(`(${fornecedorFilter.join(' or ')})`);
    }
    if (state.solicitante && state.solicitante.length) {
      const solicitantesFilter = state.solicitante.map(solicitante => `(solicitante = ${solicitante.id})`);
      filters.push(`(${solicitantesFilter.join(' or ')})`);
    }

    return filters.join(' and ');
  },
};
